export enum ReleaseScreenNames {
  MAIN = 'release',
}
